<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="昵称" prop="nickname">
                <el-input v-model="query.nickname" placeholder="请输入用户昵称" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="用户ID" prop="wdId">
                <el-input v-model="query.wdId" placeholder="请输入苇渡ID" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="query.phone" placeholder="请输入手机号" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="反馈日期" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="反馈用户名称" align="center" prop="nickname"></el-table-column>
            <el-table-column label="反馈用户ID" align="center" prop="wdId"></el-table-column>
            <el-table-column label="手机号码" align="center" prop="phone"></el-table-column>
            <el-table-column label="反馈时间" align="center" prop="feedbackTime"></el-table-column>
            <el-table-column label="反馈内容" align="center" prop="feedbackContent"></el-table-column>
            <el-table-column label="反馈图片" align="center" prop="feedbackImages">
                <template slot-scope="{ row }">
                    <div v-if="formatImage(row.feedbackImages).length > 0">
                        <el-image :src="formatImage(row.feedbackImages).img" class="w-10 h-10"
                            :preview-src-list="formatImage(row.feedbackImages).imgs"></el-image>
                        <span>共{{ formatImage(row.feedbackImages).length }}张</span>
                    </div>
                    <div v-else>
                        暂无图片
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/user/feedback/detail')">
                <template slot-scope="{ row }">
                    <el-link :underline="false" type="primary" @click="handleDetail(row)">
                        查看详情
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { feedbackPage } from "@/api/user/list";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                nickname: "",
                wdId: "",
                phone: "",
                date: [],
                mjFlag: 0,
                pageNo: 1,
                pageSize: 10,
            }
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date && this.query.date[0] ? this.query.date[0] + " 00:00:00" : "",
                endTime: this.query.date && this.query.date[1] ? this.query.date[1] + " 23:59:59" : ""
            };
            delete params.date;
            feedbackPage(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records || [];
                    this.total = result.total || 0;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        formatImage(images) {
            let img = '', imgs = [], length = 0;
            if (images) {
                img = images.split(',')[0];
                imgs = images.split(',');
                length = images.split(',').length;
            }
            return { img, imgs, length };
        },
        handleDetail(row) {
            this.$router.push({ path: "/user/feedbackDetail", query: { id: row.id } });
        },
    },
};
</script>